<div [hidden]="selectedConversionTableToEdit">
  <div class="row mt-20">
    <div class="col-sm-4">
      <label>Conversion Table</label>

      <app-link-item-picker [datasource]="conversionTables" placeholder="Please select..." displayExpr="Name"
        valueExpr="Id" [isReadOnly]="false" [isRequired]="false" [(value)]="conversionTableId"
        [itemTemplate]="itemTemplate" [fieldTemplate]="fieldTemplate" [selectedItem]="selectedConversionTable"
        (selectedItemChange)="selectedConversionTableChanged($event)">

        <ng-template #itemTemplate let-item="item">
          <div class="conversion-table" [class.conversion-table-universal]="item?.IsUniversal">
            <span>{{item.Name}}</span>
          </div>
        </ng-template>

        <ng-template #fieldTemplate let-item="item">
          <div class="conversion-table" [class.conversion-table-universal]="item?.IsUniversal">
            <span>{{item?.Name}}</span>
          </div>
        </ng-template>
      </app-link-item-picker>

    </div>
    <div class="col-sm-8">
      <label>Description</label>
      <p class="form-control-static">{{selectedConversionTable?.Description}}</p>
    </div>
  </div>
  <br class="xs-20" />
  <div class="btn-toolbar">
    <div class="btn-group">
      <button id="btnNewConversionTable" class="btn btn-primary btn-sm"
        *bizPermissionRequired="'Partner_Action_ConversionTableStructureCreate'" [disabled]="isEditing"
      (click)="new()">New Conversion Table</button>
    </div>

    <ng-container
      *bizPermissionRequired="'Partner_Action_InternalPartner'; evaluator:evaluatePermissions; trigger: selectedPartner">
      <div class="btn-group">
        @if (editAllowed) {
          <button id="btnEditStructure" class="btn btn-primary btn-sm"
          [disabled]="!selectedConversionTable || isEditing" (click)="edit()">Edit Table Structure</button>
        }
      </div>
      <div class="btn-group">
        @if (deleteAllowed) {
          <button id="btnDeleteConversionTable" class="btn btn-primary btn-sm"
          [disabled]="!selectedConversionTable || isEditing" (click)="delete()">Delete Table</button>
        }
      </div>
      <div class="btn-group">
        <button id="btnExportConversionTable" class="btn btn-link btn-sm"
          *bizPermissionRequired="'Partner_Action_ConversionTableStructureExport'"
        [disabled]="isEditing || !selectedConversionTable" (click)="export()">Export Conversion Table</button>
      </div>
      <div class="btn-group">
        <button id="btnImportConversionTable" class="btn btn-link btn-sm"
          *bizPermissionRequired="'Partner_Action_ConversionTableStructureImport'" [disabled]="isEditing"
        (click)="importStructure()">Import Conversion Table</button>
      </div>

      <div class="btn-group">
        <app-change-log-link *bizPermissionRequired="'Partner_Action_ShowLog'"
          [title]="'Conversion table log '+ $safeNavigationMigration(selectedConversionTable?.Name)" [showIcon]="false"
          [disabled]="!selectedConversionTable">
          <app-change-log-link-entity type="ConversionTable" [id]="$safeNavigationMigration(selectedConversionTable?.Id)" [includeChildren]="true"
          [includeGrandChildren]="true"></app-change-log-link-entity>
        </app-change-log-link>
      </div>
    </ng-container>
  </div>

  <br class="xs-10" />
  <div class="nav-tabs-filter">
    <ul ngbNav class="nav-tabs" [(activeId)]="selectedTab">
      <li ngbNavItem="values">
        <a ngbNavLink class="btn" [attr.disabled]="isEditing ? '' : null">Values</a>
      </li>
      @if (selectedConversionTable?.IsUniversal && partnerSpecificAllowed) {
        <li ngbNavItem="partnerValues">
          <a ngbNavLink class="btn" [attr.disabled]="isEditing ? '' : null">Partner Specific Values</a>
        </li>
      }
    </ul>
  </div>

  <ep-partner-conversion-table [selectedPartner]=selectedPartner [hidden]="selectedTab !== 'values'"
    [currentConversionTable]="selectedConversionTable"
  (editModeChange)="changeEditMode($event)"></ep-partner-conversion-table>
  <ep-partner-conversion-table [selectedPartner]=selectedPartner [hidden]="selectedTab !== 'partnerValues'"
    [currentConversionTable]="selectedConversionTable" (editModeChange)="changeEditMode($event)"
  [partnerId]="partnerId"></ep-partner-conversion-table>
</div>

<div [hidden]="!selectedConversionTableToEdit">
  <div class="row">
    <div class="col-sm-6">
      <ep-partner-conversion-table-structure [conversionTable]="selectedConversionTableToEdit"
        (saved)="structureSaved($event)" (cancelled)="structureCancelled()"
      [partnerId]="partnerId"></ep-partner-conversion-table-structure>
    </div>
  </div>
</div>